import React from 'react';
import { ThemeProvider } from '@emotion/react';
import {
  primaryTheme,
  secondaryTheme,
  secondaryRebrandTheme,
  ThemeType,
} from 'radiance-ui/lib/constants';

import CONFIG from 'jsx/constants/config';

interface RadianceThemeProviderProps {
  children: React.ReactNode;
  theme?: ThemeType;
}

const getThemeByDomain = (isAgencyRebrandEnabled: boolean | undefined) => {
  if (CONFIG.isCurologyApp || !CONFIG.isAgencyApp) {
    return primaryTheme;
  }

  return isAgencyRebrandEnabled ? secondaryRebrandTheme : secondaryTheme;
};

export const RadianceThemeProvider = ({
  children,
  theme: themeArg,
}: RadianceThemeProviderProps) => {
  const theme = themeArg ?? getThemeByDomain(CONFIG.isAgencyRebrandEnabled);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
